import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {LoginDesktopPerkboxLogo, UnauthedHeader} from "../styled"

interface Props {}

const HeaderLoginMobile: FC<Props> = () => {
  return (
    <UnauthedHeader>
      <Flex padding={2}>
        <LoginDesktopPerkboxLogo id="logo-login-header" />
      </Flex>
    </UnauthedHeader>
  )
}

export default HeaderLoginMobile
